export const DEFAULT_MAP_LAT = 48.137154;
export const DEFAULT_MAP_LNG = 11.576124;
export const DEFAULT_MAP_ZOOM = 2;
